<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Rijschool in Groningen nodig?</h1>
      <p>
        Wil je graag rijlessen gaan volgen en ben je op zoek naar een goede én
        betaalbare rijschool in Groningen? Dan zit je goed op
        Rijscholenvergelijker.nl. Hier heb je de gelegenheid om helemaal gratis
        en vrijblijvend offertes aan te vragen van rijscholen in heel Nederland.
        Vul je postcode in op de website, geef aan welk rijbewijs je wilt gaan
        behalen en wij zorgen ervoor dat de beste rijscholen in Groningen binnen
        een dag contact met je zullen opnemen. Je hoeft op die manier nauwelijks
        iets te doen, maar hebt toch de mogelijkheid om de rijscholen in je
        omgeving te vergelijken op bijvoorbeeld hun uurtarief en
        slagingspercentage. Kies voor de beste rijschool in Groningen, slaag
        binnen de kortste keren voor je examen en bespaar ook nog eens tot
        honderden euro’s!
      </p>

      <h2>Alle rijbewijzen</h2>
      <p>
        Op Rijscholenvergelijker.nl kun je niet alleen terecht als je je
        ‘normale’
        <nuxt-link to="/informatie-over-rijscholen"> rijbewijs </nuxt-link> wilt
        gaan halen; ook degenen die graag met een aanhanger willen rijden, voor
        hun
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-a">
          motorrijbewijs
        </nuxt-link>
        willen gaan of het
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-c">
          rijbewijs C
        </nuxt-link>
        in de wacht willen slepen zijn hier aan het goede adres. Op eenvoudige
        wijze kom je in contact met meerdere rijscholen in Groningen, zodat je
        de scholen niet één voor één hoeft te benaderen. Vergelijk deze
        <nuxt-link to="/"> rijscholen </nuxt-link> in alle rust met elkaar en
        kies voor de rijschool in Groningen waar jij denkt het snelst en
        goedkoopst je rijbewijs te kunnen behalen!
      </p>

      <h2>Rijscholen in Groningen nu benaderen?</h2>
      <p>
        Vul vandaag nog je gegevens in, zorg ervoor dat je de volgende dag al
        wordt benaderd door verschillende rijscholen in Groningen en laat je
        informeren over hun tarieven en statistieken, zoals het
        slagingspercentage. Daarnaast heb je misschien aanvullende vragen: kun
        je een gratis proefles krijgen? Is er begeleiding in de vorm van
        theorielessen mogelijk? Maak zorgvuldig een beslissing en bespaar
        uiteindelijk tot honderden euro’s op je rijbewijs door te kiezen voor de
        beste rijschool in Groningen!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Rijschool in Groningen nodig? Vergelijk hier gratis offertes!',
      headDescription:
        'Wil je graag rijlessen gaan volgen? Welk rijbewijs je ook nodig hebt: op Rijscholenvergelijker.nl vraag je offertes aan van rijscholen in Groningen! ',
    }
  },
}
</script>
